import dateRenderer from './date'

const createdAtRenderer = dateRenderer('createdAt')

export default createdAtRenderer
